import _ from 'lodash';
import { translate } from '../utils/translate/translations';
import fetchWithCache from './fetchWithCache';

const flattenDriveTypes = (driveTypes) => {
  let result = [];
  _.forEach(driveTypes, (bodyTypes, driveType) => {
    _.forEach(bodyTypes, (bodyType, bodyTypeId) => {
      _.forEach(bodyType.trims, (trim) => {
        result.push(
          _.assign({}, trim, {
            driveType: driveType,
            cabSize: bodyType.cabSize,
            bodyTypeId: bodyTypeId,
            bodyTypeName: bodyType.displayName,
            trimName: trim.name,
            msrp: trim.msrp,
            styleId: trim.styleId,
          })
        );
      });
    });
  });
  return result;
};

const normalizeResponse = (data) => {
  _.forEach(data.groups, (values) => {
    _.forEach(values, (x, key) => {
      if (!x.disclosure) {
        x.disclosure =
          key === '26' || key === '27'
            ? translate('fuel.efficiency.disclosure')
            : '';
      }
    });
  });
  data.options = flattenDriveTypes(data.driveTypes);
  return data;
};

const fetchFeatures = ({ v3ServicesPath, modelPath }) => {
  const url = `${v3ServicesPath}/features-specs/comparison/${modelPath}`;
  return fetchWithCache(url).then(normalizeResponse);
};

export default fetchFeatures;
